export default __webpack_public_path__ + "static/media/co-med-logo-3.3900d191.png";